"use strict";

export class CardCarousel {
  constructor() {
    // #AC Note: This was 100% achieveable via Drupal 
    // $(".paragraph--type--card-carousel>.row>.block-content").each(function() {
    //   $(this)
    //     .children(".field:not(.field--name-field-cards)")
    //     .wrapAll('<div class="block-content-title"></div>');
    // });
    $(".paragraph--type--card-carousel .field--name-field-cards").each(
      function() {
        if ($(this).children().length > 1) {
          $(this).addClass("carousel");
          $(this).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            // autoplay: true,
            // autoplaySpeed: 2000,
            arrows: true,
            centerMode: false,
            nextArrow: '<button type="button" class="slick-next"><span class="icon-chevron"></span></button>',
            prevArrow: '<button type="button" class="slick-prev"><span class="icon-chevron"`></span></button>',
            responsive: [
              // {
              //   breakpoint: 1440,
              //   settings: {
              //     slidesToShow: 2,
              //     slidesToScroll: 1
              //   }
              // },
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
        }
      }
    );
  }
}
